export default __webpack_public_path__ + "static/media/processoSeletivo.7a44e088.jpg";